/* ==========================================================================
   delivery-date.js
   Fills "Get it between: Thu, Oct 8 - Sun, Oct 11" in every
   .estimate-delivery-date-wrapper on the page, including wrappers that
   arrive later (quick view popup, ajax-loaded sections).

   The number of days is NOT set here: it is read from the wrapper's
   data-min-days / data-max-days, which the delivery snippet prints.
   ========================================================================== */
(function () {
  // The snippet loads this file every time it is rendered. Set up only once.
  if (window.deliveryDateReady) return;
  window.deliveryDateReady = true;

  const WRAPPER = '.estimate-delivery-date-wrapper';
  const DEFAULT_MIN_DAYS = 2;
  const DEFAULT_MAX_DAYS = 5;

  function formatDate(date) {
    return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function daysFrom(value, fallback) {
    const days = parseInt(value, 10);
    return Number.isNaN(days) ? fallback : days;
  }

  function initDeliveryDate(wrapper) {
    // The metafield and restock versions have no range element, nothing to fill.
    const target = wrapper.querySelector('#delivery-date-range');
    if (!target) return;

    const today = new Date();
    const first = formatDate(addDays(today, daysFrom(wrapper.dataset.minDays, DEFAULT_MIN_DAYS)));
    const last = formatDate(addDays(today, daysFrom(wrapper.dataset.maxDays, DEFAULT_MAX_DAYS)));

    target.textContent = first === last ? first : `${first} - ${last}`;
  }

  function initWithin(root) {
    if (root.matches && root.matches(WRAPPER)) initDeliveryDate(root);
    root.querySelectorAll(WRAPPER).forEach(initDeliveryDate);
  }

  // 1. wrappers already on the page
  initWithin(document);

  // 2. wrappers added later (quick view popup)
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) initWithin(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
